import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  setNavigationAction,
  resetNavigationAction,
} from 'app/shared-components/store/headerSlice';

export default function useTopHeader(title: string, options?: { tooltip?: string }): void {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setNavigationAction({ title, tooltip: options?.tooltip }));

    return () => {
      dispatch(resetNavigationAction());
    };
  }, [dispatch, title, options?.tooltip]);
}
